import { HTTP } from '@/http-common'

function privatAuth (authData) {
  let data = JSON.stringify(authData)

  return HTTP.get('/companies').then((response) => {
    let company = response.data['results'][0]

    return HTTP.post('/companies/' + company.id + '/privat24-auth', data, {
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      }
    })
  })
}

function privatOtpAuth (authData) {
  let data = JSON.stringify(authData)

  return HTTP.get('/companies').then((response) => {
    let company = response.data['results'][0]

    return HTTP.post('/companies/' + company.id + '/privat24-otp-auth', data, {
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      }
    })
  })
}

export { privatAuth, privatOtpAuth }



// WEBPACK FOOTER //
// ./src/services/privat_auth.service.js